export interface IRamsOptions {
    text: string;
    textLine2?: string;
    textLine3?: string;
    value: string;
    priorityValue?: string;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ramsROptions: IRamsOptions[] = [
    { text: 'Minder dan 1 x per 30 jaar', value: '1', priorityValue: '1' },
    { text: '1 x per 30 jaar  tot 1 x per 10 jaar', value: '2', priorityValue: '2' },
    { text: '1 x per 10 jaar  tot 1 x per jaar', value: '3', priorityValue: '3' },
    { text: '1 x per jaar tot 1 x per maand', value: '4', priorityValue: '4' },
    { text: '1 x per maand tot 1 x per week', value: '5', priorityValue: '5' },
    { text: '1 x per week', value: '6', priorityValue: '6' },
];

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ramsAOptions: IRamsOptions[] = [
    { text: 'Volledig beschikbaar', value: '1', priorityValue: '1' },
    { text: 'Bijna volledig beschikbaar', value: '2', priorityValue: '2' },
    { text: 'Meestal bechikbaar', value: '3', priorityValue: '3' },
    { text: 'Beperkt beschikbaar', value: '4', priorityValue: '4' },
    { text: 'Zeer beperkt beschikbaar', value: '5', priorityValue: '5' },
    { text: 'Niet beschikbaar', value: '6', priorityValue: '6' },
];

// export const ramsAOptions: IRamsOptions[] = [
//     { text: 'Langzaam verkeer: < 2 uur', textLine2: 'Auto- en Busverkeer: < 1 uur', textLine3: 'Tram en Beroepsvaart, natte functies: < 0,5 uur', value: '1', priorityValue: '1' },
//     { text: 'Langzaam verkeer: 2-4 uur', textLine2: 'Auto- en Busverkeer: 1-2 uur', textLine3: 'Tram en Beroepsvaart, natte functies: 0,5-1 uur', value: '2', priorityValue: '2' },
//     { text: 'Langzaam verkeer: > 4 uur < 2 dagen', textLine2: 'Auto- en Busverkeer: > 2 uur < 1 dag', textLine3: 'Tram en Beroepsvaart, natte functies: > 1 uur < 2 uur', value: '3', priorityValue: '3' },
//     { text: 'Langzaam verkeer: > 2 dagen < 2 weken', textLine2: 'Auto- en Busverkeer: > 1 dag < 1 week', textLine3: 'Tram en Beroepsvaart, natte functies: > 2 uur < 12 uur', value: '4', priorityValue: '4' },
//     { text: 'Langzaam verkeer: > 2 weken < 2 maanden', textLine2: 'Auto- en Busverkeer: > 1 week < 1 maand', textLine3: 'Tram en Beroepsvaart, natte functies: > 12 uur < 1 week', value: '5', priorityValue: '5' },
//     { text: 'Langzaam verkeer: > 2 maanden', textLine2: 'Auto- en Busverkeer: > 1 maand', textLine3: ' Tram en Beroepsvaart, natte functies: > 2 weken', value: '6', priorityValue: '6' }
// ];

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ramsSOptions: IRamsOptions[] = [
    { text: 'Geen veiligheidsincident', value: '1', priorityValue: '1' },
    { text: 'Ongeval/incident zonder letsel', value: '2', priorityValue: '2' },
    { text: 'Ongeval met middelmatig letsel', value: '3', priorityValue: '3' },
    { text: 'Ongeval met niet blijvend zwaar letsel', value: '4', priorityValue: '4' },
    { text: 'Ongeval met blijvend letsel', value: '5', priorityValue: '5' },
    { text: 'Dodelijk ongeval', value: '6', priorityValue: '6' },
];

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ramsCOptions: IRamsOptions[] = [
    { text: 'Conform ambitieniveau', value: '1', priorityValue: '1' },
    { text: '1 Niveau lager dan ambitieniveau', value: '2', priorityValue: '2' },
    { text: '2 Niveaus lager dan ambitieniveau', value: '3', priorityValue: '3' },
    { text: 'Achterstallig Onderhoud ', value: '4', priorityValue: '4' },
];

export const ramsEcOptions: IRamsOptions[] = [
    { text: 'Geen kosten', value: '1', priorityValue: '1' },
    { text: 'Lager dan € 1.000', value: '2', priorityValue: '2' },
    { text: '€ 1.000 tot € 10.000', value: '3', priorityValue: '3' },
    { text: '€ 10.000 tot € 100.000', value: '4', priorityValue: '4' },
    { text: '€ 100.000  tot € 1 miljoen', value: '5', priorityValue: '5' },
    { text: '> € 1 miljoen', value: '6', priorityValue: '6' },
];

export const ramsEnvOptions: IRamsOptions[] = [
    { text: 'Geen gevolgen', value: '1', priorityValue: '1' },
    { text: 'Gevolgen voor milieu beperkt, lokaal en beheersbaar', value: '2', priorityValue: '2' },
    { text: 'Gevolgen voor milieu lokaal, lichte verontreiniging', value: '3', priorityValue: '3' },
    { text: 'Gevolgen voor milieu lokaal, verontreiniging die sanering behoeft', value: '4', priorityValue: '4' },
    { text: 'Grootschalige verontreiniging bodem/water, maatregelen nodig', value: '5', priorityValue: '5' },
    {
        text: 'Ernstige milieuschade',
        textLine2: 'Ingrijpende herstellende maatregelen nodig met (mogelijk) blijvende schade',
        textLine3: 'Impact/ hinder voor regio (gebied > 5 km)',
        value: '6',
        priorityValue: '6',
    },
];

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ramsPOptions: IRamsOptions[] = [
    { text: 'Geen imagoschade', value: '1', priorityValue: '1' },
    {
        text: 'Negatieve berichtgeving in lokale media',
        textLine2: 'AM moet zich verantwoorden naar AO',
        textLine3: 'Interne verdeeldheid binnen een bestuurslaag',
        value: '2',
        priorityValue: '2',
    },
    {
        text: 'Negatieve berichtgeving in lokale media',
        textLine2: 'AO moet zich verantwoorden naar staf wethouders',
        textLine3: 'Georganiseerde ontevredenheid binnen een bestuurslaag',
        value: '3',
        priorityValue: '3',
    },
    {
        text: 'Negatieve berichtgeving in regionale media',
        textLine2: 'Wethouder moet zich verantwoorden naar collega B&W',
        textLine3: 'Georganiseerde ontevredenheid tussen meerdere bestuurslagen',
        value: '4',
        priorityValue: '4',
    },
    {
        text: 'Negatieve berichtgeving in landelijke media',
        textLine2: 'College B & W moet zich verantwoorden naar de Gemeenteraad',
        textLine3: 'Geen overeenstemming tussen bestuurslagen',
        value: '5',
        priorityValue: '5',
    },
    { text: 'Negatieve berichtgeving in internationale media', textLine2: 'Kamervragen', value: '6', priorityValue: '6' },
];

export function getTotalPriorityValue(
    // eslint-disable-next-line @typescript-eslint/naming-convention
    ramsRValue?: string,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    ramsAValue?: string,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    ramsSValue?: string,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    ramsCValue?: string,
    ramsEcValue?: string,
    ramsEnvValue?: string,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    ramsPValue?: string,
) {
    let maxPriorityValue: string | undefined = '0';

    if (ramsRValue && (ramsAValue || ramsSValue || ramsCValue || ramsEcValue || ramsEnvValue || ramsPValue)) {
        maxPriorityValue = getMaxPriorityValue(ramsAOptions, ramsAValue, maxPriorityValue);
        maxPriorityValue = getMaxPriorityValue(ramsSOptions, ramsSValue, maxPriorityValue);
        maxPriorityValue = getMaxPriorityValue(ramsCOptions, ramsCValue, maxPriorityValue);
        maxPriorityValue = getMaxPriorityValue(ramsEcOptions, ramsEcValue, maxPriorityValue);
        maxPriorityValue = getMaxPriorityValue(ramsEnvOptions, ramsEnvValue, maxPriorityValue);
        maxPriorityValue = getMaxPriorityValue(ramsPOptions, ramsPValue, maxPriorityValue);
        const totalValue = parseInt(maxPriorityValue ?? '0', 10) + parseInt(ramsRValue, 10);
        return totalValue;
    }
    return 0;
}

export function getWeightedPriorityValue(
    // eslint-disable-next-line @typescript-eslint/naming-convention
    ramsRValue?: string,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    ramsAValue?: string,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    ramsSValue?: string,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    ramsCValue?: string,
    ramsEcValue?: string,
    ramsEnvValue?: string,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    ramsPValue?: string,
) {
    const totalValue = getTotalPriorityValue(ramsRValue, ramsAValue, ramsSValue, ramsCValue, ramsEcValue, ramsEnvValue, ramsPValue);
    if (totalValue === 7) {
        return '2';
    } else if (totalValue === 8) {
        return '3';
    } else if (totalValue > 8) {
        return '4';
    } else if (totalValue > 1) {
        return '1';
    }
    return '0';
}

function getMaxPriorityValue(options: IRamsOptions[], value?: string, maxPriorityValue?: string) {
    if (value) {
        const ramsRecord = options.find((item) => item.value === value);
        if (ramsRecord) {
            if (parseInt(ramsRecord.priorityValue ?? '0', 10) > parseInt(maxPriorityValue ?? '0', 10)) {
                return ramsRecord.priorityValue;
            }
        }
    }
    return maxPriorityValue;
}
